module.exports = __webpack_public_path__ + "img/Logout.49856994.svg";